import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IErrorCode {
  id: number;
  sms_provider_id: number;
  local_code: string;
  internal_code: string;
  message: string;
}

interface IErrorCodesData {
  list?: Array<IErrorCode>;
  pageNo: number;
  pageSize: number;
  totalCount?: number;
  message?: { text: string; type: string };
}

const initialState: IErrorCodesData = {
  pageNo: 1,
  pageSize: 20,
  list: [],
  totalCount: 0,
  message: { text: "", type: "" },
};

const errorCodesSlice = createSlice({
  name: "error_reference",
  initialState,
  reducers: {
    setErrorCodesList: (state, _action: PayloadAction<IErrorCodesData>) => {
      state.list = _action.payload.list;
      state.pageNo = _action.payload.pageNo;
      state.pageSize = _action.payload.pageSize;
      state.totalCount = _action.payload.totalCount;
    },

    setErrorCodeMessage: (
      state,
      _action: PayloadAction<{ text: string; type: string }>
    ) => {
      state.message = _action.payload;
    },
  },
});

export const { setErrorCodesList, setErrorCodeMessage } =
  errorCodesSlice.actions;

export default errorCodesSlice.reducer;
